export default __webpack_public_path__ + "static/media/LS.e7f61c22.svg";